import { z } from 'zod';

// ---------------------------------------------------------------------------
// Revenue detail — per-client breakdown row
// ---------------------------------------------------------------------------

export const RevenueDetailSchema = z.object({
  client_id: z.number(),
  client_name: z.string(),
  transfer_fees: z.number(),
  fx_revenue: z.number(),
  total_client_revenue: z.number(),
});

export type RevenueDetail = z.infer<typeof RevenueDetailSchema>;

// ---------------------------------------------------------------------------
// Revenue aggregate response — from GET /api/revenue
// ---------------------------------------------------------------------------

export const RevenueResponseSchema = z.object({
  total_revenue: z.number(),
  wire_transfer_fees: z.number(),
  fx_margins: z.number(),
  details: z.array(RevenueDetailSchema),
});

export type RevenueResponse = z.infer<typeof RevenueResponseSchema>;

// ---------------------------------------------------------------------------
// Date range filter state
// ---------------------------------------------------------------------------

export interface RevenueDateRange {
  from: string; // ISO date string YYYY-MM-DD
  to: string; // ISO date string YYYY-MM-DD
}

/**
 * Returns the default date range: last 30 days ending today.
 */
export function getDefaultDateRange(): RevenueDateRange {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 30);
  return {
    from: from.toISOString().slice(0, 10),
    to: to.toISOString().slice(0, 10),
  };
}

// ---------------------------------------------------------------------------
// Chart color constants — UI identity
// ---------------------------------------------------------------------------

export const CHART_COLORS = {
  wireFees: '#6B0F1A', // Primary brand (burgundy)
  fxMargins: '#2563eb', // Blue (good contrast)
} as const;
